var metypeHome = global.metypeHome || {};

metypeHome.metypeLogin = function() {
  this.initMetypeLogin = this.initMetypeLogin || require("./pages/metype_home/init").default;
  this.initMetypeLogin.apply(this, arguments);
}

// General
metypeHome.__initial_callbacks = metypeHome.q;

metypeHome.q = {
  push: function(fargs) {
    try {
      fargs[0]();
    } catch(e) {
      console && console.error && console.error(e);
    }
  }
}

metypeHome.loaded = true;

export default metypeHome;



// WEBPACK FOOTER //
// ./app/javascript/metype-home.js